import React from 'react';

const Context = React.createContext('restrict');
const ResultContext = React.createContext('restrictResult');

const { Provider, Consumer } = Context;

export { Provider, Consumer, Context, ResultContext };
